<template>
  <div class="allBlock">
    <div class="firstBlock">
      <div class="firstBlock_Title">{{firstBlock.title}}</div>
    </div>
    <div class="secondBlock">
      <div class="secondBlock_MainTitle">{{secondBlock.MainTitle}}</div>
      <div class="secondBlock_AddedTitle">{{secondBlock.AddedTitle}}</div>
      <div class="secondBlock_Flow">
        <img class="secondBlock_Flow_Img" :src=secondBlock.img>
        <div class="secondBlock_RightBlock">
          <div class="secondBlock_RightBlock_IconBlock" v-for="(item,index) in secondBlock.IconBlockList" :key="index">
            <img class="secondBlock_RightBlock_IconBlock_Img" :src=item.img>
            <div class="secondBlock_RightBlock_IconBlock_Title">{{item.title}}</div>
            <div class="secondBlock_RightBlock_IconBlock_Text">{{item.text}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="secondBlock_RightBlock_Consulting">{{secondBlock.Consulting}}</div>
  </div>

</template>

<script>
    export default {
      name: "ServiceAndSupport",
      data() {
        return {
           firstBlock:{
             title:"专业支持 · 贴心服务 · 高效响应"
           },
          secondBlock:{
            MainTitle:"以客户为中心的“管家式”服务",
            AddedTitle:"围绕机构成长的全生命周期，提供“N对1”的陪伴服务",
            img:"https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup_sr.png",
            IconBlockList:[
              {img:"https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup_zsgjfw.png",title:"1V1专属管家服务",text:"以客户为中心进行1V1专属管家服务"},
              {img:"https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup_dzfw.png",title:"专业的定制服务",text:"为客户定制贴心服务，满足各种定制需求"},
              {img:"https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup_shfw.png",title:"即时的售后服务",text:"尽心尽力为客户提供专业的售后保障"},
              {img:"https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup_bjhh.png",title:"365日保驾护航",text:"为客户提供365日全天量的保驾护航"},
            ],
            Consulting:"业务咨询：0531-82952188"
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
   .allBlock{
     margin: 0;
     padding: 0;
     display: flex;
     flex-direction: column;
     align-items: center;
   }
   .firstBlock{
     width: 100%;
     height: 520px;
     background-image: url("https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/serSup.png");
     background-size: cover;
     display: flex;
   }
   .firstBlock_Title{
     width: 516px;
     height: 50px;
     font-size: 36px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 700;
     color: #0267FE;
     line-height: 50px;
     margin-left: 260px;
     margin-top: 235px;
   }
   .secondBlock{
     height: 945px;
     width: 1920px;
     display: flex;
     flex-direction: column;
     align-items: center;
   }
   .secondBlock_MainTitle{
     width: 392px;
     height: 39px;
     font-size: 28px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 400;
     color: #333333;
     line-height: 39px;
     margin-top: 120px;
   }
   .secondBlock_AddedTitle{
     width: 440px;
     height: 25px;
     font-size: 18px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 400;
     color: #666666;
     line-height: 25px;
     margin-top: 16px;
   }
   .secondBlock_Flow{
     display: flex;
     height: 580px;
     width: 1424px;
   //align-items: center;
     margin-top: 60px;
   }
   .secondBlock_Flow_Img{
     width: 560px;
     height: 550px;
     border-radius: 0px 0px 0px 0px;
     opacity: 1;
   }
   .secondBlock_RightBlock{
     display: flex;
     height: 434px;
     width: 740px;
     flex-wrap: wrap;
     justify-content: space-between;
     align-items: space-between;
     margin-left: 124px;
   }
   .secondBlock_RightBlock_IconBlock{
     width: 350px;
     height: 197px;
     background: #FFFFFF;
     border-radius: 10px 10px 10px 10px;
     opacity: 1;
     border: 1px solid #F6F6F6;
     align-items: center;
     display: flex;
     flex-direction: column;
   }
   .secondBlock_RightBlock_IconBlock_Img{
     height: 60px;
     width: 60px;
     margin-top: 27px;
   }
   .secondBlock_RightBlock_IconBlock_Title{
     width: 158px;
     height: 28px;
     font-size: 20px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 400;
     color: #333333;
     line-height: 28px;
     margin-top: 12px;
     text-align: center;
   }
   .secondBlock_RightBlock_IconBlock_Text{
     width: 252px;
     height: 20px;
     font-size: 14px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 400;
     color: #666666;
     line-height: 20px;
     margin-top: 16px;
     text-align: center;
   }
   .secondBlock_RightBlock_Consulting{
     position: absolute;
     width: 370px;
     height: 66px;
     background-color: #0267FE;
     border-radius: 8px;
     font-size: 24px;
     font-family: PingFang SC, PingFang SC;
     font-weight: 400;
     color: #FFFFFF;
     line-height: 66px;
     text-align: center;
     margin-top: 1265px;
     margin-left: 312px;
   }
</style>
